import { render, staticRenderFns } from "./MultiStep.vue?vue&type=template&id=b1b6b064&scoped=true"
import script from "./MultiStep.vue?vue&type=script&lang=js"
export * from "./MultiStep.vue?vue&type=script&lang=js"
import style0 from "./MultiStep.vue?vue&type=style&index=0&id=b1b6b064&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1b6b064",
  null
  
)

export default component.exports